import {useCustomerStore} from "~/modules/common/stores/customers";
import {storeToRefs} from "pinia";

export default defineNuxtRouteMiddleware((to, from) => {
    if (!to.meta) {
        console.log('no meta');
        return;
    }
    if(to.name === "nutzungsbedingungen"){
        return navigateTo('/', {redirectCode: 302 })
    }

    const requiredRoles: string[] = <string[]>to.meta['roles'];

    if (!requiredRoles || requiredRoles.length === 0) {
        return;
    }
    const { $authStore} = useNuxtApp();
    const user = $authStore;
    const {currentCustomer: userCustomer} = storeToRefs(useCustomerStore());
    const {data, signOut} = useAuth();

    if (!!data.value?.error) {
        console.log('signing out unauthenticated user');
        signOut({callbackUrl: "/"});
    } else if (!user.currentUser || user.currentUser.id !== data.value?.user?.id) {
        /*
         * `?.user?.id` — nicht `?.user.id`. Die Fragezeichen-Kette hoerte vorher
         * nach `data.value` auf: Kam eine Sitzung OHNE Benutzer herein, warf
         * diese Zeile, und die Navigation endete auf einer nackten Fehlerseite.
         */
        return user.setUser(data.value?.user).then(_=> {
            let userRoles = userCustomer.value?.roles || [];

            if (to.name === "registration" && !userRoles.some(role => role.includes("REGISTERED"))) {
                // console.log("registration already finished");
                return navigateTo('/dashboard/aktuelles', { redirectCode: 302 });
            }

            if (to.name !== "registration" && userRoles.some(role => role.includes("REGISTERED"))) {
                console.log("must perform registration");
                if (!!to.name && to.name.toString().includes('basket')){
                    return navigateTo(`/registration?basketType=${to.query.type}`, { redirectCode: 302 })
                }
                return navigateTo('/registration', { redirectCode: 302 });
            }

            // TODO check roles
            return Promise.resolve(true);
        }).catch(async (fehler: any) => {
            /*
             * ══ SAGEN, WAS LOS IST (Betreiber-Entscheidung 31.08.2026) ═══════
             *
             * Schlaegt das Laden des Kontos fehl, brach hier die Navigation ab
             * und Nuxt zeigte seine eigene Fehlerseite: die Ueberschrift „500"
             * und darunter „Response returned an error code". Der Mensch davor
             * erfuhr nichts — weder was schiefging noch was zu tun ist.
             *
             * GEMESSEN: Genau das sah man auf `/registration`, wenn zu einer
             * Adresse noch ein Konto mit fremder Keycloak-Kennung lag. Das
             * Backend nennt diesen Fall inzwischen beim Namen; hier wird der
             * Text nur noch durchgereicht, statt ihn zu verschlucken.
             *
             * KEIN VERSCHLUCKEN: Es bleibt eine Fehlerseite — sie sagt jetzt
             * nur, was sie meint. Ohne Text vom Server steht wenigstens ein
             * brauchbarer Satz da statt einer Zahl.
             */
            const antwort = fehler?.response;
            const text = (await antwort?.text?.().catch(() => '')) ?? '';
            const sauber = String(text).trim().replace(/^"|"$/g, '');
            showError({
                statusCode: antwort?.status ?? 500,
                statusMessage: sauber
                    || 'Ihr Zugang konnte nicht geladen werden. Bitte melden Sie sich erneut an.',
            });
        })
    } else if (!!user.currentUser) {
        let userRoles = userCustomer.value?.roles || [];

        if (to.name === "registration" && !userRoles.some(role => role.includes("REGISTERED"))) {
            // console.log("registration already finished");
            return navigateTo('/dashboard/aktuelles');
        }

        if (to.name !== "registration" && userRoles.some(role => role.includes("REGISTERED"))) {
            // console.log("must perform registration");
            return navigateTo('/registration');
        }

    }
    if(to.name === "dashboard") {
        return navigateTo('/dashboard/aktuelles');
    }
})
